/** Default page when `initialPage` is omitted. */
export const DEFAULT_INITIAL_PAGE = 1;

/** Default download filename when none is provided. */
export const DEFAULT_DOWNLOAD_FILENAME = 'document.pdf';

/** Minimum allowed PDF viewer scale (25%). */
export const MIN_PDF_SCALE = 0.25;

/** Maximum allowed PDF viewer scale (600%). */
export const MAX_PDF_SCALE = 6;

/** Multiplicative zoom step per zoom in/out action. */
export const PDF_ZOOM_STEP = 1.1;

/** Inset applied when scrolling a non-first page into view. */
export const PAGE_SCROLL_PADDING_PX = 24;

/** Treat scroll deltas smaller than this as already at the jump target. */
export const PAGE_SCROLL_SETTLE_PX = 1;

/** Thumbnail canvas target width in CSS pixels. */
export const THUMBNAIL_WIDTH_PX = 108;

/** Pixel tolerance when detecting toolbar overflow. */
export const TOOLBAR_OVERFLOW_TOLERANCE_PX = 1;
